





























  import {
    format
  } from 'date-fns'
  import Vue from 'vue'
  import {
    Component,
    Prop
  } from 'vue-property-decorator'
  import Information from '../../../api/v2/models/information'
  import {
    checkMobile
  } from '../../utils/utils'

  @Component({})
  export default class InformationView extends Vue {
    @Prop({
      required: true
    })
    item: Information

    mobile = checkMobile()

    dateFormat(date: Date) {
      return format(date, 'YYYY/MM/DD HH:mm')
    }
  }
